module.exports = __webpack_public_path__ + "img/ADC_logo@2x.cde3762e.png";